import { Spinner as ShadSpinner } from '@ps/ds/ui/spinner'

export interface SpinnerProps extends React.ComponentPropsWithoutRef<typeof ShadSpinner> {}

export const Spinner = (props: SpinnerProps) => {
  return <ShadSpinner {...props} />
}

Spinner.displayName = 'Spinner'
